module.exports = __webpack_public_path__ + "static/media/cube.226c230d.svg";